// extracted by mini-css-extract-plugin
module.exports = {"container":"login_modal-module__container--390rz","close":"login_modal-module__close--3pTOb","title":"login_modal-module__title--1hexs"};